import {
  faExclamationTriangle,
  faSpinner,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styled from "styled-components";
import { RoundedCorners } from "../../theme/Mixins";
import NotificationCount from "../NotificationCount";
import {
  ButtonProps as Props,
  handleColor,
  handleSize,
} from "./ButtonStyleHandlers";

const StyledButton = styled.button<{
  color: string;
  size: string;
}>`
  ${({ size }) => handleSize(size)};
  ${({ color }) => handleColor(color)};

  display: block;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
  border: none;
  background-size: 200% auto;
  ${RoundedCorners}

  button:not(:disabled) {
    cursor: pointer;
  }
`;

const Button = ({
  color = "primary",
  size = "medium",
  label,
  icon = null,
  showThrobber = false,
  badgeCount = 0,
  dataCy,
  ...props
}: Props) => {
  return (
    <>
      <StyledButton
        color={color}
        size={size}
        data-cy={dataCy}
        style={badgeCount > 0 ? { position: "relative" } : null}
        {...props}
      >
        {badgeCount > 0 && (
          <span
            style={{
              position: "absolute",
              top: "-1rem",
              right: "-0.5rem",
            }}
          >
            <NotificationCount count={badgeCount} data-cy="badge-count" />
          </span>
        )}
        {color === "alert" ? (
          <FontAwesomeIcon
            icon={faExclamationTriangle}
            style={{ marginRight: "1rem" }}
          />
        ) : (
          ""
        )}
        {label}
        {icon && <span style={{ marginLeft: "1rem" }}>{icon}</span>}
        {showThrobber && (
          <FontAwesomeIcon icon={faSpinner} className="fa-spin" />
        )}
      </StyledButton>
    </>
  );
};

export default Button;
